/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum DrugCoverageStatus {
  covered = 'covered',
  notCovered = 'notCovered',
  unknown = 'unknown',
}
